import React from 'react';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  className?: string;
  showText?: boolean;
}

const Logo: React.FC<LogoProps> = ({ size = 'medium', className = '', showText = true }) => {
  const sizeClasses = {
    small: 'h-8',
    medium: 'h-12',
    large: 'h-16'
  };

  // Tentar carregar a logo do public/images
  const logoSrc = '/images/logo.svg';

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {/* Logo original */}
      <div className="relative">
        <img
          src={logoSrc}
          alt="SwimmingPool Logo"
          className={`${sizeClasses[size]} w-auto object-contain`}
          onError={(e) => {
            // Se a logo falhar, mostrar fallback
            const target = e.target as HTMLImageElement;
            target.style.display = 'none';
            const parent = target.parentElement;
            if (parent) {
              const fallback = parent.querySelector('.logo-fallback') as HTMLElement;
              if (fallback) fallback.style.display = 'flex';
            }
          }}
        />
        {/* Fallback SVG caso a imagem não carregue */}
        <div className="logo-fallback hidden items-center justify-center">
          <svg
            className={`${sizeClasses[size]} w-auto`}
            viewBox="0 0 120 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#3B82F6" />
                <stop offset="100%" stopColor="#1E40AF" />
              </linearGradient>
            </defs>
            <circle cx="30" cy="90" r="20" fill="url(#logoGradient)" />
            <path
              d="M 50 70 Q 60 50, 70 60 Q 80 70, 90 50 Q 100 30, 110 40"
              stroke="url(#logoGradient)"
              strokeWidth="12"
              strokeLinecap="round"
              fill="none"
            />
          </svg>
        </div>
      </div>
      
      {/* Texto "swimmingpool" - opcional (só mostra se showText=true e logo não carregar) */}
      {showText && (
        <span className={`font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-blue-700 logo-text ${size === 'small' ? 'text-xl' : size === 'medium' ? 'text-2xl' : 'text-3xl'}`}>
          swimmingpool
        </span>
      )}
    </div>
  );
};

export default Logo;
